import React, { useState, useEffect, useRef } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Popover from "../../common/components/popover/popover.js";
import { projects as getProjects } from '../../common/api/projects';
import ProjectsList from "../Projects/ProjectsList";
import Facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logoWhite from '../../common/media/cc_logo_white.svg';

import Modal from "../../common/components/modal/Modal";
import {getMyCCBaseUrlWithMerchantCode} from "../../common/util/pathUtils";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';

const LandingPage = ({ merchantCode, fetchedImpact, oneOfConfig }) => {
    const [projects, setProjects] = useState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => {setIsModalVisible(true);};
    const closeModal = () => {
        if (isModalVisible) setIsModalVisible(false);
    }
    
    const numberOfContributions = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase();
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears} trees have in one year.`;
    
        
    useEffect(() => {
        getProjects(null, merchantCode).then(response => response.json()).then(data => setProjects(data));

    }, []);

    return (
        <div onClick={closeModal}>
            <div className="heroSection">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="heroContent">
                                <h1>Climate Focused <br/>Financial Advice</h1>
                                <p>We want to help you on your climate journey. Learn about your carbon <br/>footprint and how you can reduce your environmental impact. </p>
                                <a href={`${getMyCCBaseUrlWithMerchantCode(merchantCode)}/calculator`} target="_blank" className="btn btn-primary">CALCULATE MY FOOTPRINT</a>
                                <div className="d-flex align-items-center pwdBy text-white mt-4">
                                    <p className="my-0 mr-3">Powered by</p>
                                    <img src={logoWhite} style={{ height: 24 }} alt="Powered by carbonclick" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="text-center pl-xl-120">
                                <a target="_blank" href="https://www.tgn.co.nz/">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/TGN-logo_ivjcvj.png" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="climateSection">
                <div className="container-cus text-center">
                    <h2 className="text-black">Our Cumulative Impact</h2>
                    <div className="row mobile-hide">
                        <div className="col-md-4">
                            <div className="climateBoxes">
                                <div className="d-flex img-bx">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/image_42_s9c6kl.png" alt="Image" />
                                </div>
                                <div className="climateText">
                                    <h3 className="text-primary">{numberOfContributions}</h3>
                                    <p>Individuals taking climate action</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="climateBoxes">
                                <div className="d-flex img-bx">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/image_55_wiihom.png" alt="Image" />
                                </div>
                                <div className="climateText">
                                    <h3 className="text-primary">{carbonOffsetImpact}</h3>
                                    <p><span className="text-cap">{carbonOffsetImpactUnit}</span> Of CO2 Offset</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="climateBoxes">
                                <div className="d-flex img-bx">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/image_52_dxujuk.png" alt="Image" />
                                </div>
                                <div className="climateText">
                                    <h3 className="text-primary">{treeGrowthYears}</h3>
                                    <p>
                                        <span className="mr-2">Trees</span>
                                        <Popover content={treeMetric}>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="7" cy="7" r="7" fill="#007C47"/>
                                            <path d="M5.90771 8.88818V8.50879C5.90771 8.18066 5.97778 7.89526 6.11792 7.65259C6.25806 7.40991 6.5144 7.15186 6.88696 6.87842C7.24585 6.62207 7.48169 6.41357 7.59448 6.25293C7.71069 6.09229 7.7688 5.91284 7.7688 5.7146C7.7688 5.49243 7.68677 5.32324 7.52271 5.20703C7.35864 5.09082 7.12964 5.03271 6.83569 5.03271C6.323 5.03271 5.73853 5.2002 5.08228 5.53516L4.52344 4.41235C5.28564 3.98511 6.09399 3.77148 6.94849 3.77148C7.65259 3.77148 8.21143 3.94067 8.625 4.27905C9.04199 4.61743 9.25049 5.0686 9.25049 5.63257C9.25049 6.00854 9.16504 6.33325 8.99414 6.60669C8.82324 6.88013 8.49854 7.18774 8.02002 7.52954C7.69189 7.77222 7.4834 7.95679 7.39453 8.08325C7.30908 8.20972 7.26636 8.37549 7.26636 8.58057V8.88818H5.90771ZM5.74365 10.6416C5.74365 10.3545 5.82056 10.1375 5.97437 9.99048C6.12817 9.84351 6.35205 9.77002 6.646 9.77002C6.92969 9.77002 7.14844 9.84521 7.30225 9.99561C7.45947 10.146 7.53809 10.3613 7.53809 10.6416C7.53809 10.9116 7.45947 11.1252 7.30225 11.2825C7.14502 11.4363 6.92627 11.5132 6.646 11.5132C6.35889 11.5132 6.13672 11.438 5.97949 11.2876C5.82227 11.1338 5.74365 10.9185 5.74365 10.6416Z" fill="white"/>
                                        </svg>
                                        </Popover>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show mt-4 text-center">
                        <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                            <div key="1">
                                <div className="climateBoxes">
                                    <div className="d-flex img-bx">
                                        <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/image_42_s9c6kl.png" alt="Image" />
                                    </div>
                                    <div className="climateText">
                                        <h3 className="text-primary">{numberOfContributions}</h3>
                                        <p>Individuals taking climate action</p>
                                    </div>
                                </div>
                            </div>

                            <div key="2">
                                <div className="climateBoxes">
                                    <div className="d-flex img-bx">
                                        <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/image_55_wiihom.png" alt="Image" />
                                    </div>
                                    <div className="climateText">
                                        <h3 className="text-primary">{carbonOffsetImpact}</h3>
                                        <p>{carbonOffsetImpactUnit} Of CO2 Offset</p>
                                    </div>
                                </div>
                            </div>

                            <div key="3">
                                <div className="climateBoxes">
                                    <div className="d-flex img-bx">
                                        <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/image_52_dxujuk.png" alt="Image" />
                                    </div>
                                    <div className="climateText">
                                        <h3 className="text-primary">{treeGrowthYears}</h3>
                                        <p>
                                            <span className="mr-2">Trees</span>
                                            <Popover content={treeMetric}>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="7" cy="7" r="7" fill="#007C47"/>
                                                <path d="M5.90771 8.88818V8.50879C5.90771 8.18066 5.97778 7.89526 6.11792 7.65259C6.25806 7.40991 6.5144 7.15186 6.88696 6.87842C7.24585 6.62207 7.48169 6.41357 7.59448 6.25293C7.71069 6.09229 7.7688 5.91284 7.7688 5.7146C7.7688 5.49243 7.68677 5.32324 7.52271 5.20703C7.35864 5.09082 7.12964 5.03271 6.83569 5.03271C6.323 5.03271 5.73853 5.2002 5.08228 5.53516L4.52344 4.41235C5.28564 3.98511 6.09399 3.77148 6.94849 3.77148C7.65259 3.77148 8.21143 3.94067 8.625 4.27905C9.04199 4.61743 9.25049 5.0686 9.25049 5.63257C9.25049 6.00854 9.16504 6.33325 8.99414 6.60669C8.82324 6.88013 8.49854 7.18774 8.02002 7.52954C7.69189 7.77222 7.4834 7.95679 7.39453 8.08325C7.30908 8.20972 7.26636 8.37549 7.26636 8.58057V8.88818H5.90771ZM5.74365 10.6416C5.74365 10.3545 5.82056 10.1375 5.97437 9.99048C6.12817 9.84351 6.35205 9.77002 6.646 9.77002C6.92969 9.77002 7.14844 9.84521 7.30225 9.99561C7.45947 10.146 7.53809 10.3613 7.53809 10.6416C7.53809 10.9116 7.45947 11.1252 7.30225 11.2825C7.14502 11.4363 6.92627 11.5132 6.646 11.5132C6.35889 11.5132 6.13672 11.438 5.97949 11.2876C5.82227 11.1338 5.74365 10.9185 5.74365 10.6416Z" fill="white"/>
                                            </svg>
                                            </Popover>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>

            <div className="investmentSec">
                <div className="container-cus">
                    <div className="row">
                        <div className="col-md-6">
                            <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010336/Enterprise/The%20Green%20Network/Rectangle_667_xjxvse.png" />
                        </div>
                        <div className="col-md-6">
                            <div className="max-485 ml-auto">
                                <h3 className="mt-0 text-primary">Investment, Insurance and Individual Carbon Neutrality</h3>
                                <p>We already help client manage risk, finances and monitor investments, so why not also add in the elephant in the room - carbon footprints and how to achieve carbon neutrality! It’s kind of another of those things, insurances, wills, taxes, getting fit, home maintenance etc - things that we have such good intentions about, that we intend to do and just because we don’t have enough time we tend to put off and never get around to it.</p>
                                <p>Our carbon footprint is becoming more and more an actual thing we need to think about and now we have the tools to do so!</p>
                            </div>
                        </div>
                    </div>
                    <div className="investmentText text-center">
                        <h3 className="text-primary">We’ve partnered with CarbonClick to give you <br/>the the tools to take climate action</h3>
                        <p>We’re seeing a growing transformation across the planet, but it’s a long journey ahead and we need <br/>climate action now. Reducing your carbon footprint and offsetting the remainder are some of the most <br/>impactful ways to limit your environmental impact. </p>
                    </div>
                </div>
            </div>
            
            <div className="darkCalculateSec">
                <div className="container-cus">
                    <div className="row">
                        <div className="col-md-7">
                            <div className="textParts">
                                <h3 className="liteGreen">Elevate your climate action <br/>journey by understanding <br/>your emissions</h3>
                                <p>CarbonClick have created a simple footprint calculator to help <br/>you understand your carbon emissions. From there, sign in to <br/>their portal, get relevant educational content and the ability to <br/>buy impactful carbon offsets from New Zealand native forest and <br/>international clean energy projects that make a real, traceable <br/>difference. </p>
                            </div>
                        </div>
                        <div className="col-md-5 text-md-right">
                            <div className="logo-parts text-center d-inline-block">
                                <div className="secLogo"><img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010335/Enterprise/The%20Green%20Network/Group_yycpji.png" /></div>
                                <a href={`${getMyCCBaseUrlWithMerchantCode(merchantCode)}/calculator`} target="_blank" className="btn btn-primary-outline">Calculate my footprint</a>
                                <div className="d-flex align-items-center justify-content-center pwdBy text-white mt-4">
                                    <p className="my-0 mr-3">Powered by</p>
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648187969/Enterprise/The%20Green%20Network/carbon-logo_fjz1nz_c1lh2y.png" alt="Powered by carbonclick" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="projects projects-sec text-center">
                <div className="container-cus">
                    <div className="projectHead">
                        <h3 className="text-black mt-0">Support Projects That Fight Climate Change</h3>
                        <p className="sml">We support only the highest quality carbon offsetting projects around the <br/>world, to bring you peace of mind and results.</p>
                    </div>
                    <ProjectsList title={null} projects={projects} />
                </div>
            </div>

            <div className="contributionSec">
                <div className="contributionBox text-center mx-auto">
                    <h3 className="liteGreen">Make a one-off contribution</h3>
                    <p className="text-white">Help the planet with a simple click! Simply select how <br/>much you wish to contribute with a one-time purchase <br/>and start offsetting now.</p>
                    <a onClick={() => { showModal() }} className="btn btn-primary-outline">CONTRIBUTE NOW</a>
                </div>
            </div>

            <div className="faq-sec">
                <div className="container-cus">
                    <div className="row">
                        <div className="col-md-6">
                            <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1648010337/Enterprise/The%20Green%20Network/Group_4632_meh4k3.png" />
                        </div>
                        <div className="col-md-6">
                            <h3>Climate Friendly FAQs</h3>
                            <div className="mb-3 center text-align-start">
                                <Accordian title={"Who are CarbonClick?"} >
                                    CarbonClick is a New Zealand technology company that exists to reverse climate change. By making carbon offsetting simple, trustworthy and cost effective,  we empower businesses and their customers with the tools to start tackling their carbon emissions.
                                </Accordian>
                                <Accordian title={"What does carbon offsetting do?"}>
                                    <span className='mb-2 d-block'>CarbonClick follows industry best practice to ensure that the offsets provided have a real, measurable impact on mitigating climate change.</span>
                                    Projects are scrutinised against their independently verified selection methodology, which uses many of the same stringent requirements of ICROA Code of Best Practice, such as true additionality, ensuring credible baseline reporting and verifying project developers integrity. Only projects that have considerable co-benefits are considered, 
                                    such as improving biodiversity, creating sustainable jobs, empowering women and minorities and improving community health and wellbeing.
                                </Accordian>
                                <Accordian title={"What are carbon credits?"} >
                                    A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.
                                </Accordian>
                                <Accordian title={"Where does the money go?"} >
                                    The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.
                                </Accordian>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="w-100 footer-img" >
                <div className="container">
                    <div className="footerImg text-brown">
                        <div className="footer-width">
                            <p className="footer-powered text-white mt-0">POWERED BY</p>
                            <div className="row align-items-center">
                                <div className='col-md-auto col-6 width-50'>
                                    <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                        <img style={{ height: 24 }} className="footer-logo" src={logo} />
                                    </a>
                                </div>
                                <div className="col-md-4 col-6 ml-auto width-50">
                                    <div className="text-right">
                                        <a className="mr-1" href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                            <img style={{ width: 30 }} src={Facebook} alt="carbonclick" />
                                        </a>
                                        <a className="mr-1" href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                            <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                        </a>
                                        <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                            <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <hr className="footer-hr"/>
                            <div className="row links bottom-links">
                                <div className="col">
                                    <div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div>
                                        <div className=""><a className="medium" href="mailto:hello+tgn@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                                    </div>
                                </div>
                            </div>  
                        </div>  
                    </div>

                </div>
            </div>
            <Modal small={true} handleClose={() => setIsModalVisible(false)} show={isModalVisible}>
                <section className="mb-3 h-100">
                    <iframe
                        frameBorder="0"
                        allowFullScreen
                        src={`${getMyCCBaseUrlWithMerchantCode(merchantCode)}/purchase-offset?currency=NZD&cost=10`}>
                    </iframe>
                </section>
            </Modal>
        </div>
    )
}


export default LandingPage;